<div class="modules-subtypes-card">
  <div class="card-header">
    <h3 class="section-title">Moduler og indholdstemaer</h3>
    <p class="section-desc">
      Administrer versioner for moduler og indholdstemaer. Versioners
      datointervaller må ikke overlappe.
    </p>
  </div>

  @if (errorMessage) {
  <p class="error-message">{{ errorMessage }}</p>
  }

  <mat-tab-group animationDuration="0ms">
    <!-- Moduler -->
    <mat-tab label="Moduler">
      <div class="tab-content">
        <div class="two-panel">
          <div class="list-panel">
            <div class="list-panel-nav">
              <div class="search-bar">
                <mat-form-field appearance="outline" class="search-field">
                  <mat-label>Søg moduler</mat-label>
                  <mat-icon matPrefix class="search-icon">search</mat-icon>
                  <input
                    matInput
                    [(ngModel)]="moduleSearch"
                    (ngModelChange)="onModuleSearchChange()"
                    placeholder="Navn..."
                  />
                  @if (moduleSearch) {
                  <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="clearModuleSearch()"
                    aria-label="Ryd søgning"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                  }
                </mat-form-field>
              </div>
              <div class="list-toolbar">
                <span class="entity-count"
                  >{{ filteredModulesForList.length }} af
                  {{ modules.length }}</span
                >
                <button
                  mat-icon-button
                  type="button"
                  class="sort-toggle"
                  (click)="toggleModuleSort()"
                  [attr.aria-label]="
                    moduleSortAsc ? 'Sortér Z–A' : 'Sortér A–Å'
                  "
                  [title]="moduleSortAsc ? 'Sortér Z–A' : 'Sortér A–Å'"
                >
                  <mat-icon>{{
                    moduleSortAsc ? "arrow_downward" : "arrow_upward"
                  }}</mat-icon>
                </button>
              </div>
              @if (moduleLetterIndex.length > 1) {
              <div class="letter-index">
                <button
                  type="button"
                  class="letter-chip"
                  [class.active]="!moduleLetterFilter"
                  (click)="moduleLetterFilter = null"
                >
                  Alle
                </button>
                @for (letter of moduleLetterIndex; track letter) {
                <button
                  type="button"
                  class="letter-chip"
                  [class.active]="moduleLetterFilter === letter"
                  (click)="toggleModuleLetterFilter(letter)"
                >
                  {{ letter }}
                </button>
                }
              </div>
              }
            </div>
            <div class="add-entity-row">
              <button
                mat-raised-button
                color="primary"
                class="add-entity-btn"
                (click)="openAddModule()"
                [disabled]="showAddModule"
              >
                + Tilføj
              </button>
            </div>
            <!-- Add new module form -->
            @if (showAddModule) {
            <div class="form-block add-entity-form">
              <h5>Nyt modul</h5>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Navn</mat-label>
                <input
                  matInput
                  [(ngModel)]="addModuleForm.name"
                  placeholder="Modulnavn"
                  required
                />
              </mat-form-field>
              <div class="form-actions">
                <button mat-button (click)="cancelAddModule()">Annuller</button>
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="!addModuleForm.name.trim() || saving"
                  (click)="saveAddModule()"
                >
                  {{ saving ? "Opretter..." : "Opret modul" }}
                </button>
              </div>
            </div>
            } @if (loadingModules) {
            <p class="loading-message">Henter moduler...</p>
            } @if (!loadingModules && filteredModulesForList.length) {
            <div class="entity-list-scroll">
              @for (group of groupedModules; track group.letter) {
              <div class="entity-group">
                @if (groupedModules.length > 1) {
                <div class="entity-group-header">{{ group.letter }}</div>
                }
                <ul class="entity-list">
                  @for (m of group.items; track m.module_id) {
                  <li
                    [class.selected]="selectedModule?.module_id === m.module_id"
                    (click)="selectModule(m)"
                  >
                    <span class="entity-name">{{ m.name }}</span>
                  </li>
                  }
                </ul>
              </div>
              }
            </div>
            } @if (!loadingModules && modules.length &&
            filteredModulesForList.length === 0) {
            <p class="empty-message">
              Ingen moduler matcher søgningen{{
                moduleLetterFilter ? ' for "' + moduleLetterFilter + '"' : ""
              }}.
            </p>
            } @if (!loadingModules && modules.length === 0) {
            <p class="empty-message">Ingen moduler fundet.</p>
            }
          </div>
          @if (selectedModule) {
          <div class="detail-panel">
            @if (!editingModuleName) {
            <div class="detail-heading">
              <h4 class="detail-title">{{ selectedModule.name }}</h4>
              <button mat-button type="button" (click)="openEditModuleName()">
                Rediger navn
              </button>
              <button
                mat-button
                type="button"
                color="warn"
                class="delete-entity-btn"
                [disabled]="saving"
                (click)="deleteModule()"
              >
                Slet
              </button>
            </div>
            } @if (editingModuleName) {
            <div class="form-block name-edit-block">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Modulnavn</mat-label>
                <input matInput [(ngModel)]="editModuleNameForm.name" />
              </mat-form-field>
              <div class="form-actions">
                <button
                  mat-button
                  type="button"
                  (click)="cancelEditModuleName()"
                >
                  Annuller
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="!editModuleNameForm.name.trim() || saving"
                  (click)="saveEditModuleName()"
                >
                  {{ saving ? "Gemmer..." : "Gem" }}
                </button>
              </div>
            </div>
            } @if (selectedModule.visibility && !editingModuleName) {
            <p class="detail-meta">
              Synlighed: {{ selectedModule.visibility }}
            </p>
            }
            <div class="toolbar">
              <button
                mat-raised-button
                color="primary"
                (click)="openAddModuleVersion()"
              >
                + Tilføj version
              </button>
            </div>
            @if (loadingModuleVersions) {
            <p class="loading-message">Henter versioner...</p>
            }
            <!-- Add version form -->
            @if (showAddModuleVersion) {
            <div class="form-block">
              <h5>Tilføj ny version</h5>
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Start dato</mat-label>
                  <input
                    matInput
                    type="date"
                    [(ngModel)]="addModuleVersionForm.valid_from"
                    required
                  />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Slut dato</mat-label>
                  <input
                    matInput
                    type="date"
                    [(ngModel)]="addModuleVersionForm.valid_to"
                  />
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Vedligeholdelsesminutter</mat-label>
                  <input
                    matInput
                    type="number"
                    min="0"
                    [(ngModel)]="addModuleVersionForm.maintenance_minutes"
                  />
                </mat-form-field>
              </div>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Beskrivelse (Dansk)</mat-label>
                <textarea
                  matInput
                  [(ngModel)]="addModuleVersionForm.description_da"
                  rows="2"
                ></textarea>
              </mat-form-field>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Beskrivelse (Engelsk)</mat-label>
                <textarea
                  matInput
                  [(ngModel)]="addModuleVersionForm.description_en"
                  rows="2"
                ></textarea>
              </mat-form-field>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Beskrivelse (Tysk)</mat-label>
                <textarea
                  matInput
                  [(ngModel)]="addModuleVersionForm.description_de"
                  rows="2"
                ></textarea>
              </mat-form-field>
              <div class="form-actions">
                <button mat-button (click)="cancelAddModuleVersion()">
                  Annuller
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="!addModuleVersionForm.valid_from || saving"
                  (click)="saveAddModuleVersion()"
                >
                  {{ saving ? "Gemmer..." : "Opret version" }}
                </button>
              </div>
            </div>
            }
            <!-- Version list -->
            @if (!loadingModuleVersions && moduleVersions.length) {
            <ul class="version-list">
              @for (v of moduleVersions; track v.version_id) {
              <li class="version-row">
                @if (editingModuleVersionId !== v.version_id) {
                <div class="version-info">
                  <span class="version-dates">{{ v.dateRange }}</span>
                  <span class="version-meta"
                    >{{ v.maintenance_minutes }} min</span
                  >
                  @if (getDescriptionLines(v.descriptions).length) {
                  <div class="version-desc-block">
                    <span class="version-desc-label">Beskrivelse:</span>
                    @for (line of getDescriptionLines(v.descriptions); track
                    line.lang) {
                    <div class="version-desc-lines">
                      <span class="version-desc-lang">{{ line.label }}:</span>
                      {{ line.text }}
                    </div>
                    }
                  </div>
                  }
                </div>
                <div class="version-actions">
                  <button mat-button (click)="openEditModuleVersion(v)">
                    Rediger
                  </button>
                  <button
                    mat-button
                    class="btn-remove"
                    (click)="deleteModuleVersion(v)"
                  >
                    Slet
                  </button>
                </div>
                } @else {
                <div class="form-block inline-edit">
                  <div class="form-row">
                    <mat-form-field appearance="outline">
                      <mat-label>Start dato</mat-label>
                      <input
                        matInput
                        type="date"
                        [(ngModel)]="editModuleVersionForm.valid_from"
                      />
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Slut dato</mat-label>
                      <input
                        matInput
                        type="date"
                        [(ngModel)]="editModuleVersionForm.valid_to"
                      />
                    </mat-form-field>
                  </div>
                  <div class="form-row">
                    <mat-form-field appearance="outline">
                      <mat-label>Vedligeholdelsesminutter</mat-label>
                      <input
                        matInput
                        type="number"
                        min="0"
                        [(ngModel)]="editModuleVersionForm.maintenance_minutes"
                      />
                    </mat-form-field>
                  </div>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Beskrivelse (Dansk)</mat-label>
                    <textarea
                      matInput
                      [(ngModel)]="editModuleVersionForm.description_da"
                      rows="2"
                    ></textarea>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Beskrivelse (Engelsk)</mat-label>
                    <textarea
                      matInput
                      [(ngModel)]="editModuleVersionForm.description_en"
                      rows="2"
                    ></textarea>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Beskrivelse (Tysk)</mat-label>
                    <textarea
                      matInput
                      [(ngModel)]="editModuleVersionForm.description_de"
                      rows="2"
                    ></textarea>
                  </mat-form-field>
                  <div class="form-actions">
                    <button mat-button (click)="cancelEditModuleVersion()">
                      Annuller
                    </button>
                    <button
                      mat-raised-button
                      color="primary"
                      [disabled]="saving"
                      (click)="saveEditModuleVersion()"
                    >
                      Gem
                    </button>
                  </div>
                </div>
                }
              </li>
              }
            </ul>
            } @if (!loadingModuleVersions && selectedModule &&
            !showAddModuleVersion && moduleVersions.length === 0) {
            <p class="empty-message">
              Ingen versioner. Klik "Tilføj version" for at oprette en.
            </p>
            }
          </div>
          } @if (!selectedModule && !loadingModules) {
          <div class="detail-panel empty">
            <p>Vælg et modul til venstre.</p>
          </div>
          }
        </div>
      </div>
    </mat-tab>

    <!-- Indholdstemaer -->
    <mat-tab label="Indholdstemaer">
      <div class="tab-content">
        <div class="two-panel">
          <div class="list-panel">
            <div class="list-panel-nav">
              <div class="search-bar">
                <mat-form-field appearance="outline" class="search-field">
                  <mat-label>Søg indholdstemaer</mat-label>
                  <mat-icon matPrefix class="search-icon">search</mat-icon>
                  <input
                    matInput
                    [(ngModel)]="subtypeSearch"
                    (ngModelChange)="onSubtypeSearchChange()"
                    placeholder="Navn..."
                  />
                  @if (subtypeSearch) {
                  <button
                    mat-icon-button
                    matSuffix
                    type="button"
                    (click)="clearSubtypeSearch()"
                    aria-label="Ryd søgning"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                  }
                </mat-form-field>
              </div>
              <div class="list-toolbar">
                <span class="entity-count"
                  >{{ filteredSubtypesForList.length }} af
                  {{ subtypes.length }}</span
                >
                <button
                  mat-icon-button
                  type="button"
                  class="sort-toggle"
                  (click)="toggleSubtypeSort()"
                  [attr.aria-label]="
                    subtypeSortAsc ? 'Sortér Z–A' : 'Sortér A–Å'
                  "
                  [title]="subtypeSortAsc ? 'Sortér Z–A' : 'Sortér A–Å'"
                >
                  <mat-icon>{{
                    subtypeSortAsc ? "arrow_downward" : "arrow_upward"
                  }}</mat-icon>
                </button>
              </div>
              @if (subtypeLetterIndex.length > 1) {
              <div class="letter-index">
                <button
                  type="button"
                  class="letter-chip"
                  [class.active]="!subtypeLetterFilter"
                  (click)="subtypeLetterFilter = null"
                >
                  Alle
                </button>
                @for (letter of subtypeLetterIndex; track letter) {
                <button
                  type="button"
                  class="letter-chip"
                  [class.active]="subtypeLetterFilter === letter"
                  (click)="toggleSubtypeLetterFilter(letter)"
                >
                  {{ letter }}
                </button>
                }
              </div>
              }
            </div>
            <div class="add-entity-row">
              <button
                mat-raised-button
                color="primary"
                class="add-entity-btn"
                (click)="openAddSubtype()"
                [disabled]="showAddSubtype"
              >
                + Tilføj
              </button>
            </div>
            <!-- Add new subtype form -->
            @if (showAddSubtype) {
            <div class="form-block add-entity-form">
              <h5>Nyt indholdstema</h5>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Navn</mat-label>
                <input
                  matInput
                  [(ngModel)]="addSubtypeForm.name"
                  placeholder="Navn"
                  required
                />
              </mat-form-field>
              <div class="form-actions">
                <button mat-button (click)="cancelAddSubtype()">
                  Annuller
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="!addSubtypeForm.name.trim() || saving"
                  (click)="saveAddSubtype()"
                >
                  {{ saving ? "Opretter..." : "Opret indholdstema" }}
                </button>
              </div>
            </div>
            } @if (loadingSubtypes) {
            <p class="loading-message">Henter indholdstemaer...</p>
            } @if (!loadingSubtypes && filteredSubtypesForList.length) {
            <div class="entity-list-scroll">
              @for (group of groupedSubtypes; track group.letter) {
              <div class="entity-group">
                @if (groupedSubtypes.length > 1) {
                <div class="entity-group-header">{{ group.letter }}</div>
                }
                <ul class="entity-list">
                  @for (s of group.items; track s.subtype_id) {
                  <li
                    [class.selected]="
                      selectedSubtype?.subtype_id === s.subtype_id
                    "
                    (click)="selectSubtype(s)"
                  >
                    <span class="entity-name">{{ s.name }}</span>
                  </li>
                  }
                </ul>
              </div>
              }
            </div>
            } @if (!loadingSubtypes && subtypes.length &&
            filteredSubtypesForList.length === 0) {
            <p class="empty-message">
              Ingen indholdstemaer matcher søgningen{{
                subtypeLetterFilter ? ' for "' + subtypeLetterFilter + '"' : ""
              }}.
            </p>
            } @if (!loadingSubtypes && subtypes.length === 0) {
            <p class="empty-message">Ingen indholdstemaer fundet.</p>
            }
          </div>
          @if (selectedSubtype) {
          <div class="detail-panel">
            @if (!editingSubtypeName) {
            <div class="detail-heading">
              <h4 class="detail-title">{{ selectedSubtype.name }}</h4>
              <button mat-button type="button" (click)="openEditSubtypeName()">
                Rediger navn
              </button>
              <button
                mat-button
                type="button"
                color="warn"
                class="delete-entity-btn"
                [disabled]="saving"
                (click)="deleteSubtype()"
              >
                Slet
              </button>
            </div>
            } @if (editingSubtypeName) {
            <div class="form-block name-edit-block">
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Navn</mat-label>
                <input matInput [(ngModel)]="editSubtypeNameForm.name" />
              </mat-form-field>
              <div class="form-actions">
                <button
                  mat-button
                  type="button"
                  (click)="cancelEditSubtypeName()"
                >
                  Annuller
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="!editSubtypeNameForm.name.trim() || saving"
                  (click)="saveEditSubtypeName()"
                >
                  {{ saving ? "Gemmer..." : "Gem" }}
                </button>
              </div>
            </div>
            } @if (selectedSubtype.visibility && !editingSubtypeName) {
            <p class="detail-meta">
              Synlighed: {{ selectedSubtype.visibility }}
            </p>
            }
            <div class="toolbar">
              <button
                mat-raised-button
                color="primary"
                (click)="openAddSubtypeVersion()"
              >
                + Tilføj version
              </button>
            </div>
            @if (loadingSubtypeVersions) {
            <p class="loading-message">Henter versioner...</p>
            } @if (showAddSubtypeVersion) {
            <div class="form-block">
              <h5>Tilføj ny version</h5>
              <div class="form-row">
                <mat-form-field appearance="outline">
                  <mat-label>Start dato</mat-label>
                  <input
                    matInput
                    type="date"
                    [(ngModel)]="addSubtypeVersionForm.valid_from"
                    required
                  />
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label>Slut dato</mat-label>
                  <input
                    matInput
                    type="date"
                    [(ngModel)]="addSubtypeVersionForm.valid_to"
                  />
                </mat-form-field>
              </div>
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Beskrivelse (da)</mat-label>
                <textarea
                  matInput
                  [(ngModel)]="addSubtypeVersionForm.description_da"
                  rows="2"
                ></textarea>
              </mat-form-field>
              <div class="form-actions">
                <button mat-button (click)="cancelAddSubtypeVersion()">
                  Annuller
                </button>
                <button
                  mat-raised-button
                  color="primary"
                  [disabled]="!addSubtypeVersionForm.valid_from || saving"
                  (click)="saveAddSubtypeVersion()"
                >
                  {{ saving ? "Gemmer..." : "Opret version" }}
                </button>
              </div>
            </div>
            } @if (!loadingSubtypeVersions && subtypeVersions.length) {
            <ul class="version-list">
              @for (v of subtypeVersions; track v.version_id) {
              <li class="version-row">
                @if (editingSubtypeVersionId !== v.version_id) {
                <div class="version-info">
                  <span class="version-dates">{{ v.dateRange }}</span>
                  @if (getDescriptionLines(v.descriptions).length) {
                  <div class="version-desc-block">
                    <span class="version-desc-label">Beskrivelse:</span>
                    @for (line of getDescriptionLines(v.descriptions); track
                    line.lang) {
                    <div class="version-desc-lines">
                      <span class="version-desc-lang">{{ line.label }}:</span>
                      {{ line.text }}
                    </div>
                    }
                  </div>
                  }
                </div>
                <div class="version-actions">
                  <button mat-button (click)="openEditSubtypeVersion(v)">
                    Rediger
                  </button>
                  <button
                    mat-button
                    class="btn-remove"
                    (click)="deleteSubtypeVersion(v)"
                  >
                    Slet
                  </button>
                </div>
                } @else {
                <div class="form-block inline-edit">
                  <div class="form-row">
                    <mat-form-field appearance="outline">
                      <mat-label>Start dato</mat-label>
                      <input
                        matInput
                        type="date"
                        [(ngModel)]="editSubtypeVersionForm.valid_from"
                      />
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Slut dato</mat-label>
                      <input
                        matInput
                        type="date"
                        [(ngModel)]="editSubtypeVersionForm.valid_to"
                      />
                    </mat-form-field>
                  </div>
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Beskrivelse (da)</mat-label>
                    <textarea
                      matInput
                      [(ngModel)]="editSubtypeVersionForm.description_da"
                      rows="2"
                    ></textarea>
                  </mat-form-field>
                  <div class="form-actions">
                    <button mat-button (click)="cancelEditSubtypeVersion()">
                      Annuller
                    </button>
                    <button
                      mat-raised-button
                      color="primary"
                      [disabled]="saving"
                      (click)="saveEditSubtypeVersion()"
                    >
                      Gem
                    </button>
                  </div>
                </div>
                }
              </li>
              }
            </ul>
            } @if (!loadingSubtypeVersions && selectedSubtype &&
            !showAddSubtypeVersion && subtypeVersions.length === 0) {
            <p class="empty-message">
              Ingen versioner. Klik "Tilføj version" for at oprette en.
            </p>
            }
          </div>
          } @if (!selectedSubtype && !loadingSubtypes) {
          <div class="detail-panel empty">
            <p>Vælg et indholdstema til venstre.</p>
          </div>
          }
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
